





import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";

@Component({
  components: {
    DataTable,
    PlanosAba,
  },
})
export default class TabPlanos extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;

  public atualizarPlano() {
    const atualizaPlanos = this.$refs.planosAba as PlanosAba;
    atualizaPlanos.fetchPlanos();
  }
}
